import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../api/methodsCfg";
import { getLatLongFromAddress } from "../utils/gis";

export const getCompanySettings = async (companyId) => {
  const response = await getRequest(`/company/${companyId}`);
  return response;
};

export const updateCompanySettings = async (companyId, payload) => {
  let x,
    y = null;
  try {
    const coordinates = await getLatLongFromAddress(
      payload.address,
      payload.city?.value?.npa,
      payload.city?.value?.label
    );
    if (!coordinates || !coordinates.latitude || !coordinates.longitude) {
      throw new Error("ADDRESS_NOT_FOUND");
    }
    x = coordinates.latitude;
    y = coordinates.longitude;
  } catch (error) {
    // Re-throw with a user-friendly error message
    if (error.message === "ADDRESS_NOT_FOUND") {
      throw new Error("ADDRESS_NOT_FOUND");
    }
    throw error;
  }
  const cleanPayload = {
    ...payload,
    city: payload.city.value ? payload.city.value.cityId : payload.cityId,
    x,
    y,
  };
  const response = await putRequest(
    `/company/update/${companyId}/${payload.name}`,
    cleanPayload,
    true
  );
  return response;
};

export const getCompanyPartners = async (companyId) => {
  const response = await getRequest(`/company/partners/${companyId}`);
  return response;
};

export const getAvailableOffers = async (companyId) => {
  const response = await getRequest(`/company/availableOffers/${companyId}`);
  return response;
};

export const putTransferMangerRole = async (companyId, payload) => {
  const response = await putRequest(
    `/company/transferManagerRole/${companyId}`,
    payload
  );
  return response;
};

export const subscribeToOffer = async (companyId, offerId) => {
  const response = await putRequest(`/company/subscribe/${companyId}`, {
    offerId,
  });
  return response;
};

export const unsubscribeToOffer = async (companyId, offerId) => {
  const response = await deleteRequest(`/company/unsubscribe/${companyId}`, {
    offerId,
  });
  return response;
};

export const deleteCompany = async (companyId) => {
  const response = await deleteRequest(`/company/${companyId}`);
  return response;
};

export const getCompanyDomains = async (companyId) => {
  const response = await getRequest(`/company/${companyId}/domains`);
  return response;
};

export const addCompanyDomain = async (companyId, domain) => {
  const response = await postRequest(`/company/${companyId}/domains`, {
    domain,
  });
  return response;
};

export const removeCompanyDomain = async (companyId, domainId) => {
  const response = await deleteRequest(
    `/company/${companyId}/domains/${domainId}`
  );
  return response;
};

export const updateCompanyMembershipConfig = async (
  companyId,
  name,
  payload
) => {
  const response = await putRequest(
    `/company/update/${companyId}/${name}`,
    payload
  );
  return response;
};
